import { mapToSearchParameters } from '@/models/search-filters';
import { tendersService } from '@/services/tenders.service';
import { getNow } from '@/util/date-util';

const initialState = () => ({
  status: {
    error: null,
    exportSelectedPending: false,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getExportTenders({ commit }, { mode, searchFilters = null, tenderIds = null }) {
    commit(searchFilters ? 'GET_EXPORT_TENDERS' : 'GET_EXPORT_SELECTED_TENDERS');

    const parameters = searchFilters ? mapToSearchParameters(searchFilters, mode) : { tenderIds };

    return tendersService.getExportTenders({ mode: mode.apiCall, parameters }).then(
      (response) => {
        commit('SUCCESS');

        const now = getNow();
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);

        link.download = `Export Aloha ${now}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      (error) => {
        commit('ERROR', error);
        throw error;
      },
    );
  },
};

const mutations = {
  GET_EXPORT_TENDERS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  GET_EXPORT_SELECTED_TENDERS(state) {
    state.status = {
      error: null,
      pending: false,
      exportSelectedPending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      exportSelectedPending: false,
      resolved: true,
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      exportSelectedPending: false,
      rejected: true,
    };
  },
};
const getters = {
  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  exportSelectedPending: (state) => state.status.exportSelectedPending,
  resolved: (state) => state.status.resolved,
  rejected: (state) => state.status.rejected,
};

export const exportTenders = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
